import { createStore } from './store';
import { DateFilterType } from '../common/date-range-filter/date-range-filter.interface';

export type HomeSelectedView = 'operational' | 'bi';

// fromDate/toDate are always both populated - equal for 1/2, potentially
// different for 3 - so API params never need to special-case a missing date.
// Re-exported from the shared DateRangeFilter control (also used by
// Shipments) rather than owned here.
export type HomeDateFilterType = DateFilterType;

export interface IHomeStoreModel {
  fromDate: Date;
  toDate: Date;
  dateFilterType: HomeDateFilterType;
  selectedView: HomeSelectedView;
}

export const initialHomeState: IHomeStoreModel = {
  fromDate: new Date(),
  toDate: new Date(),
  dateFilterType: 1,
  selectedView: 'operational'
};

export const {
  Provider: HomeStoreProvider,
  useStore: useHomeStore,
  useSetStore: useSetHomeStore
} = createStore<IHomeStoreModel>(initialHomeState);
